import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { billingOptions, departmentNotes } from '../../../utils/dropdownOptions';

export const BillingDetails = ({ formik, isReturnShipmentTab }) => {
    const values = isReturnShipmentTab ? formik.values.returnData : formik.values;
    const errors = isReturnShipmentTab ? formik.errors.returnData : formik.errors;
    const touched = isReturnShipmentTab ? formik.touched.returnData : formik.touched;
    const isMps = values.mpsPackages.length > 0;

    const handleDepartmentNotesChange = (e) => {
        if (e.target.value === '') {
            if (isReturnShipmentTab) {
                formik.setValues({
                    ...formik.values,
                    returnData: {
                        ...formik.values.returnData,
                        departmentNotesCode: e.target.value,
                        customerReference: '',
                        departmentNotesName: ''
                    }
                })
            } else {
                formik.setValues({
                    ...formik.values,
                    departmentNotesCode: e.target.value,
                    customerReference: '',
                    departmentNotesName: ''
                })
            }
            return;
        }
        const departmentNotesName = departmentNotes.find(i => i.code === e.target.value).name;

        if (isReturnShipmentTab) {
            formik.setValues({
                ...formik.values,
                returnData: {
                    ...formik.values.returnData,
                    departmentNotesCode: e.target.value,
                    customerReference: departmentNotesName,
                    departmentNotesName
                }
            })
        } else {
            formik.setValues({
                ...formik.values,
                departmentNotesCode: e.target.value,
                customerReference: departmentNotesName,
                departmentNotesName
            })
        }
    }

    const handleBillTransportationToChange = (e) => {
        formik.handleChange(e);
        if (e.target.value === 'SENDER') {
            const accountNumField = isReturnShipmentTab ? 'returnData.accountNum' : 'accountNum';
            formik.setFieldValue(accountNumField, values.senderAccountNum);
        }
    }

    return (
        <>
            <Row className='form-group'>
                <Form.Group as={Col}>
                    <Form.Label>Bill transportation to</Form.Label>
                    <Form.Select
                        name={isReturnShipmentTab ? 'returnData.billTransportationTo' : 'billTransportationTo'}
                        disabled={isMps}
                        {...formik.getFieldProps(isReturnShipmentTab ? 'returnData.billTransportationTo' : 'billTransportationTo')}
                        onChange={handleBillTransportationToChange}
                    >
                        {
                            billingOptions.map((i) => (
                                <option key={i.value} value={i.value}>{i.key}</option>
                            ))
                        }
                    </Form.Select>
                </Form.Group>
                <Form.Group as={Col}>
                    <Form.Label>Acct #</Form.Label>
                    <Form.Control
                        name={isReturnShipmentTab ? 'returnData.accountNum' : 'accountNum'}
                        type='text'
                        disabled={values.billTransportationTo === 'SENDER'}
                        {...formik.getFieldProps(isReturnShipmentTab ? 'returnData.accountNum' : 'accountNum')}
                    />
                    {
                        errors?.accountNum && touched?.accountNum ? (
                            <div className='error'>{errors?.accountNum}</div>
                        ) : null
                    }
                </Form.Group>
            </Row>
            <Form.Group className='form-group'>
                <Form.Label>Department notes</Form.Label>
                <InputGroup>
                    <Form.Select
                        name={isReturnShipmentTab ? 'returnData.departmentNotesCode' : 'departmentNotesCode'}
                        disabled={isMps}
                        onChange={handleDepartmentNotesChange}
                        value={values.departmentNotesCode}
                    >
                        <option value=''>Select an option</option>
                        {
                            departmentNotes.map((i) => (
                                <option key={i.code} value={i.code}>{i.code}</option>
                            ))
                        }
                    </Form.Select>
                    <Form.Control
                        name={isReturnShipmentTab ? 'returnData.departmentNotesName' : 'departmentNotesName'}
                        {...formik.getFieldProps(isReturnShipmentTab ? 'returnData.departmentNotesName' : 'departmentNotesName')}
                        disabled={isMps}
                    />
                </InputGroup>
            </Form.Group>
            <Form.Group className='form-group'>
                <Form.Label>Customer reference</Form.Label>
                <Form.Control
                    name={isReturnShipmentTab ? 'returnData.customerReference' : 'customerReference'}
                    disabled={isMps}
                    {...formik.getFieldProps(isReturnShipmentTab ? 'returnData.customerReference' : 'customerReference')}
                />
            </Form.Group>
            {values.returnLabelType === 'GROUND_CALL_TAG' ? null :
                <Form.Group className='form-group'>
                <Form.Label>P.O. number</Form.Label>
                <Form.Control
                    name={isReturnShipmentTab ? 'returnData.poNum' : 'poNum'}
                    disabled={isMps}
                    {...formik.getFieldProps(isReturnShipmentTab ? 'returnData.poNum' : 'poNum')}
                />
            </Form.Group>}
            {isReturnShipmentTab &&
                <>
                    <Form.Group className='form-group'>
                        <Form.Label>RMA Number</Form.Label>
                        <Form.Control
                            name='returnData.rmaNum'
                            type='text'
                            {...formik.getFieldProps('returnData.rmaNum')}
                        />
                    </Form.Group>
                    {formik.values.includeReturnLabel &&
                        <Form.Check
                            type='checkbox'
                            name='returnData.linkToOutbound'
                            label='Link to outbound'
                            checked={formik.values.returnData.linkToOutbound}
                            {...formik.getFieldProps('returnData.linkToOutbound')}
                        />
                    }
                </>
            }
        </>
    )
}